import { render, staticRenderFns } from "./exchangeInformation.vue?vue&type=template&id=090fa8b7&scoped=true"
import script from "./exchangeInformation.vue?vue&type=script&lang=js"
export * from "./exchangeInformation.vue?vue&type=script&lang=js"
import style0 from "./exchangeInformation.vue?vue&type=style&index=0&id=090fa8b7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090fa8b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090fa8b7')) {
      api.createRecord('090fa8b7', component.options)
    } else {
      api.reload('090fa8b7', component.options)
    }
    module.hot.accept("./exchangeInformation.vue?vue&type=template&id=090fa8b7&scoped=true", function () {
      api.rerender('090fa8b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/exchange/exchangeInformation.vue"
export default component.exports